import { IWithdrawal, TTransactionsList } from 'entities/Transaction';
import { commonApi } from 'shared/api/commonApi';
import { EApiTags } from 'shared/typings/enums/apiTags.enum';
import { getCookie } from 'shared/utils/getCookie';

export const transactionApi = commonApi
	.injectEndpoints({
		endpoints: (builder) => ({
			getTransactionsList: builder.query<TTransactionsList, string>({
				query: (params) => ({
					url: `/reports/balance_transactions/${params ? '?' : ''}${params}`,
				}),
			}),

			getWithdrawal: builder.query<IWithdrawal, string | undefined>({
				query: (id) => ({
					url: `withdrawal_request/${id}`,
				}),
			}),

			addWithdrawal: builder.mutation<IWithdrawal, Partial<void>>({
				query(body) {
					return {
						url: `withdrawal_request/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'POST',
						body,
					};
				},
			}),
		}),
		overrideExisting: false,
	})
	.enhanceEndpoints({
		addTagTypes: [EApiTags.SINGLE_TRANSACTION, EApiTags.TRANSACTIONS_LIST, EApiTags.CONFIG],
		endpoints: {
			getTransactionsList: {
				providesTags: [EApiTags.TRANSACTIONS_LIST],
			},
			getWithdrawal: {
				providesTags: [EApiTags.SINGLE_TRANSACTION],
			},
			addWithdrawal: {
				invalidatesTags: [EApiTags.TRANSACTIONS_LIST, EApiTags.CONFIG],
			},
		},
	});

export const { useGetTransactionsListQuery, useGetWithdrawalQuery, useAddWithdrawalMutation } = transactionApi;
